
export interface ITransaction { 
  primaryId: number;
  id: string;
  action_type: ACTION_TYPE;
  status: OperationStatusEnum;
  amount: string;
  targetAddress: string;
  createdAt?: Date;
  updatedAt: Date;
  vaa_message?: Buffer;
  fee: string | null;
  token_id: {
    id: number;
    address: string;
    chainId: number;
    unitName: string;
    name: string;
    decimals: number;
  };
  transactions: Array<{
    txnHash: string;
    chainId: number;
  }>;
  vaaMessages: Array<OperationVAA>;
}

export interface ITransactionDetails {
  primaryId: number;
  id: string;
  login_address: string;
  login_chain_id: number;
  action_type: 'withdraw' | 'deposit';
  status: OperationStatusEnum;
  amount: string;
  targetAddress: string;
  timestamp: string;
  createdAt: Date;
  updatedAt: Date;
  vaa_message?: Buffer;
  fee: string | null;
  transactions: Array<OperationTxn>;
  vaaMessages: Array<OperationVAA>;
  cctp: Array<OperationCCTP>;
}

export interface ITransfer {
  transferId: number,
  senderAddress: string,
  recipientAddress: string,
  tokenId: number,
  amount: string,
  expiredAt: number,
  whitelistId: number,
  txnId: string,
  completedAt: Date,
  status: OperationStatusEnum;
}

export interface IPendingTxn {
  id: number,
  type: ACTION_TYPE,
  amount: string,
  tokenId: number,
}

export enum ACTION_TYPE {
  D = 'deposit',
  W = "withdraw",
  T = "transfer"
}

export enum HistoryTypeTitles {
  deposit = 'deposits_history',
  withdraw = 'withdrawals_history',
  transfer = "transfers_history"
}

export interface OperationTxn {
  txn_hash: string;
  chain_id: number;
  createdAt?: Date;
  updatedAt?: Date;
  type?: TransactionType;
}

export interface OperationVAA {
  vaaId: string;
  from_chain_id: number;
  to_chain_id: number;
  sequence: number;
  emitter: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface OperationCCTP {
  id: number;
  destinationChainId: number;
  messageHash: string;
  messageBytes: string;
  status: OperationStatusEnum;
  attestationSignature: string;
  createdAt: Date;
  updatedAt: Date;
  attestationCompletedAt: Date;
}

export enum TransactionType {
  USER_TO_TMC = 'user_to_tmc',
  TMC_TO_USER = 'tmc_to_user',
  RELAYER_TO_TMC = 'relayer_to_tmc',
  RELAYER_TO_CODEX = 'relayer_to_codex',
  RELAYER_TO_CIRCLE = 'relayer_to_circle',
}

export enum TxnSequence {
  first = 1,
  attestation,
  last
}

export enum OperationStatusEnum {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
  Received = 'received',
  Success = 'success',
  Failure = 'failure',
  Dropped = 'dropped',
  Replaced = 'replaced',
  Stuck = 'stuck',
  Confirmed = 'confirmed'
}

export interface IWhiteList {
  id?: number;
  loginAddress: string;
  loginChainId: number;
  recipient: string;
  recipientChainId: number;
  tkAddress: string;
  expiredDate: number;
}

export interface IGetWhiteList {
  id: number;
  recipientAddress: string;
  tkAddress: string;
  expiredAt: number;
}

export interface  IDeleteWL {
  dtwId: number
}
